import React from "react"

/**
 * An animated loading indicator with two bouncing dots.
 */
function LoadingAnimation() {
  return (
    <div className="loading-animation">
      <div className="loading-animation--top" />
      <div className="loading-animation--bottom" />
    </div>
  )
}

export { LoadingAnimation }
export default LoadingAnimation
